<template>
  <CDialog
    @click="closeModalEsc"
    @outer-click="emit('close')"
    :show="show"
    :no-header="true"
    :custom-class="'max-w-[421px]'"
  >
    <div class="flex-y-center p-5 flex-col justify-center text-center">
      <div
        class="mb-5 flex items-center justify-center w-[72px] h-[72px] p-4 bg-yellow-100 rounded-full"
      >
        <img
          src="/images/svg/toast/warning.svg"
          alt="Warning"
          class="w-full h-full object-cover"
        />
      </div>
      <div class="max-w-[381px] text-center">
        <h5 class="mb-2 text-dark-100 font-semibold text-xl">
          {{ $t("delete_bot") }}
        </h5>
        <span class="block mb-7 text-[#535E69] font-normal">
          {{ $t(planTitle[type]) }}
        </span>
      </div>
      <RouterLink to="/bots" class="w-full">
        <CButton :text="$t('my_bots')" />
      </RouterLink>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CButton from "@/components/Common/CButton.vue";
import { computed } from "vue";

interface Props {
  show: boolean;
  type: "premium" | "free";
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
}>();

const planTitle = computed(() => {
  return {
    free: "free_plan_warning",
    premium: "premium_plan_warning",
  };
});

const closeModalEsc = computed(() => {
  return document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      emit("close");
    }
  });
});
</script>

<style scoped></style>
